import React, { Component } from 'react'
import { Alert, FormGroup, Label, Input, Button } from 'reactstrap'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import subscriptionOperations from '../../../../redux/css-admin/subscriptionManager/operations'
import ErrorBoundary from 'components/ErrorBoundary'
import Loading from 'components/Loading/Loading'

class SubscriptionSearch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      notFound: false,
      subscriptionId: '',
      nsSubscriptionId: '',
    }
  }

  handleChange = e => {
    const newState = { ...this.state }
    newState[e.target.name] = e.target.value
    this.setState(newState)
  }

  handleKeydown = e => {
    if (e.keyCode === 13) this.search()
  }

  search = () => {
    const { searchSubscriptionsAndHandle } = this.props
    const { subscriptionId, nsSubscriptionId } = this.state
    const query = subscriptionId ? { subscriptionId } : { nsSubscriptionId }
    searchSubscriptionsAndHandle(query)
  }

  render = () => {
    const { subscriptionId, nsSubscriptionId, notFound } = this.state
    const { isLoading } = this.props

    return (
      <React.Fragment>
        <h2>Subscription Search</h2>
        <hr />
        <ErrorBoundary>
          <Loading isLoading={isLoading} />
          <FormGroup>
            <Label>SecondStep Subscription ID</Label>
            <Input
              name="subscriptionId"
              onChange={this.handleChange}
              onKeyDown={this.handleKeydown}
              type="number"
              value={subscriptionId}
            />
          </FormGroup>
          <FormGroup>
            <Label>NetSuite Subscription ID</Label>
            <Input
              name="nsSubscriptionId"
              onChange={this.handleChange}
              onKeyDown={this.handleKeydown}
              type="string"
              value={nsSubscriptionId}
            />
          </FormGroup>
          <hr />
          <div className="text-right">
            <Button
              className="btn-fixed-width"
              color="primary"
              onClick={this.search}
            >
              <i className="fas fa-search" />
              &nbsp;Search
            </Button>
          </div>
          {notFound && <Alert color="warning">Not found</Alert>}
        </ErrorBoundary>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ subscriptionManager }) => {
  return {
    ...subscriptionManager,
  }
}

const mapDispatchToProps = {
  ...subscriptionOperations,
  push,
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionSearch)



// WEBPACK FOOTER //
// ./src/containers/css-admin/subscriptions/search/SubscriptionSearch.js